import React, { type ReactNode } from 'react'

function FacebookLogoIcon(props: React.ComponentPropsWithoutRef<'svg'>): ReactNode {
  return (
    <svg
      width="12"
      height="23"
      viewBox="0 0 12 23"
      fill="var(--color-icon-secondary)"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M11.1133 12.5947L11.7148 8.6416H7.89062V6.06348C7.89062 4.94629 8.40625 3.91504 10.125 3.91504H11.8867V0.520508C11.8867 0.520508 10.2969 0.219727 8.79297 0.219727C5.65625 0.219727 3.59375 2.15332 3.59375 5.59082V8.6416H0.0703125V12.5947H3.59375V22.2197H7.89062V12.5947H11.1133Z" />
    </svg>
  )
}

export default FacebookLogoIcon
